<script>
import NavBar from "@/components/NavBar.vue";
import PenalidadesManagement from "@/components/PenalidadesManagement.vue";

export default {
  name: "GerenciarPenalidades",
  components: {
    NavBar,
    PenalidadesManagement,
  }
}
</script>

<template>
  <div class="container">
    <NavBar/>
    <PenalidadesManagement/>
  </div>
</template>

<style scoped>

</style>